export const AssetsChartMixpanelEvents = {
  ASSET_CHART_SWITCH_TAB: "moving between tabs on the total balance graph",
} as const;

export const CashflowMixpanelEvents = {
  SWITCH_MONTH: "moving between months on the cashflow page",
  CONNECT_ACCOUNTS_FROM_CASHFLOW:
    "clicking on connect accounts from cashflow page",
  CONNECT_ACCOUNTS_FROM_BAR_CHART:
    "clicking on connect accounts from bar chart page",
  SWITCH_TRANSACTION_GROUP:
    "moving between accounts/cards on the cashflow page",
  SWITH_CATEGORY_TYPE: "moving between category types on the cashflow page",
  SWITCH_BANK_OR_CARD: "moving between banks/cards on the cashflow page",
  ADD_RULE: "adding a transaction rule (ignore/change category)",
  REMOVE_RULE: "removing a transaction rule (ignore/change category)",
} as const;
